/**
 * Dr.Max Categories - Logo Replacement
 * Nahrazuje text [Dr.Max] logem v kategoriích levého menu a category title
 */

function replaceDrMaxCategories() {
    // Najdi všechny linky v levém menu
    const navLinks = document.querySelectorAll('#panel-left .nav-link');

    navLinks.forEach(link => {
        const text = link.textContent.trim();

        // Pokud začína [Dr.Max], nahraď to logem
        if (text.startsWith('[Dr.Max]')) {
            // Extrahuj text za [Dr.Max]
            const restText = text.replace('[Dr.Max]', '').trim();

            // Vytvoř logo element
            const logo = document.createElement('img');
            logo.src = '/img/logo.svg';
            logo.className = 'drmax-logo';
            logo.alt = 'Dr.Max';

            // Nastav nový obsah
            link.innerHTML = '';
            link.appendChild(logo);
            link.appendChild(document.createTextNode(' ' + restText));

            // Přidej třídu pro styling
            link.classList.add('drmax-category');
        }
    });

    // Najdi všechny category title elementy
    const categoryTitles = document.querySelectorAll('.category-title');

    categoryTitles.forEach(title => {
        const text = title.textContent.trim();

        // Pokud začína [Dr.Max], nahraď to logem
        if (text.startsWith('[Dr.Max]')) {
            // Extrahuj text za [Dr.Max]
            const restText = text.replace('[Dr.Max]', '').trim();

            // Vytvoř logo element (větší pro title)
            const logo = document.createElement('img');
            logo.src = '/img/logo.svg';
            logo.className = 'drmax-logo-title';
            logo.alt = 'Dr.Max';

            // Nastav nový obsah
            title.innerHTML = '';
            title.appendChild(logo);
            title.appendChild(document.createTextNode(' ' + restText));
        }
    });
}

// Spusť po načtení DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceDrMaxCategories);
} else {
    replaceDrMaxCategories();
}

export default replaceDrMaxCategories;
